import { render } from "./AirplaneLandingIcon.vue?vue&type=template&id=c197675c"
import script from "./AirplaneLandingIcon.vue?vue&type=script&lang=js"
export * from "./AirplaneLandingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__